"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeConfigs = void 0;
var tslib_1 = require("tslib");
/**
 * Merges any number of configs together with the latter configs taking priority
 * over the former configs.
 *
 * @param configs the configs
 * @return the merged config
 */
function mergeConfigs() {
    var configs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        configs[_i] = arguments[_i];
    }
    if (configs.length === 0) {
        return {};
    }
    if (configs.length === 1) {
        return tslib_1.__assign({}, configs[0]);
    }
    return mergeConfig(configs[0], mergeConfigs.apply(void 0, configs.slice(1)));
}
exports.mergeConfigs = mergeConfigs;
/**
 * Merges the two configs together with values in config2 taking priority over
 * values in config1.
 *
 * @param config1 the first config
 * @param config2 the second config
 * @return the merged config
 */
function mergeConfig(config1, config2) {
    if (!config1) {
        return tslib_1.__assign({}, config2);
    }
    if (!config2) {
        return tslib_1.__assign({}, config1);
    }
    var mergedConfig = tslib_1.__assign(tslib_1.__assign({}, config1), config2);
    if (config1.headers || config2.headers) {
        mergedConfig.headers = tslib_1.__assign(tslib_1.__assign({}, config1.headers), config2.headers);
    }
    if (config1.params || config2.params) {
        mergedConfig.params = tslib_1.__assign(tslib_1.__assign({}, config1.params), config2.params);
    }
    return mergedConfig;
}
//# sourceMappingURL=request-utils.js.map